import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

const EVENT_GUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Event GUID for participate form data sources when the form is embedded
 * (e.g. in duna-events-information) and URL alone is not enough.
 */
@Injectable({ providedIn: 'root' })
export class ParticipateEventContextService {
  private overrideGuid: string | null = null;

  setEventGuid(guid: string | null | undefined): void {
    const trimmed = typeof guid === 'string' ? guid.trim() : '';
    this.overrideGuid = EVENT_GUID_REGEX.test(trimmed) ? trimmed : null;
  }

  resolveEventGuid(router: Router): string | null {
    if (this.overrideGuid) {
      return this.overrideGuid;
    }
    const pathFromRouter = (router.url || '').split('?')[0];
    const pathForGuid =
      pathFromRouter ||
      (typeof window !== 'undefined' ? window.location?.pathname || '' : '');
    const segments = pathForGuid.split('/');
    let eventGuid =
      segments.find((segment) => EVENT_GUID_REGEX.test(segment)) ?? null;
    if (
      !eventGuid &&
      typeof window !== 'undefined' &&
      window.location?.pathname
    ) {
      eventGuid =
        window.location.pathname
          .split('/')
          .find((segment) => EVENT_GUID_REGEX.test(segment)) ?? null;
    }
    return eventGuid;
  }
}
